import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/storefront/Header";
import { Footer } from "@/components/storefront/Footer";
import { FloatingContact } from "@/components/storefront/FloatingContact";
import ScrollToTop from "@/components/ScrollToTop";
import Maintenance from "@/pages/Maintenance";
import { useStore } from "@/context/StoreContext";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Eye } from "lucide-react";

export default function StorefrontLayout() {
  const { settings } = useStore();
  const { user, checking } = useAuth();

  if (settings === null || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="storefront-loading">
        <Loader2 className="w-8 h-8 animate-spin text-brand-blue" />
      </div>
    );
  }

  const isAdmin = !!user;
  // Visitors see the maintenance page; signed-in admins can still preview the live site.
  if (settings?.maintenance_mode && !isAdmin) {
    return (
      <>
        <ScrollToTop />
        <Maintenance />
      </>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollToTop />
      {settings?.maintenance_mode && isAdmin && (
        <div className="bg-brand-gold text-black text-center text-sm font-semibold py-2 px-4 border-b-2 border-black flex items-center justify-center gap-2" data-testid="maintenance-admin-banner">
          <Eye className="w-4 h-4" /> Maintenance mode is ON — visitors see the maintenance page. You're previewing as an admin.
        </div>
      )}
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingContact />
    </div>
  );
}
